import { IPipelineStatus } from "./IPipelineStatus";

export const EmptyPipelineStatus:IPipelineStatus  = {
      
    status_Name:"",
    isSubCategory: false,

  }